import { TextField, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Dayjs } from 'dayjs'
import { isValidDate } from 'src/utils/formatDate'

interface DatePickerMuiProps {
  label: string
  format?: string
  size?: 'small' | 'medium' | undefined
  currentValue?: Dayjs
  setCurrentValue?: (date?: Dayjs) => void
  minDate?: Dayjs
  maxDate?: Dayjs
  required?: boolean
  disableFuture?: boolean
  readOnly?: boolean
  testId?: string
}

export const DatePickerMui = ({
  label,
  format = 'DD/MM/YYYY',
  size = 'small',
  currentValue,
  setCurrentValue,
  required,
  minDate,
  maxDate,
  disableFuture,
  readOnly,
  testId,
}: DatePickerMuiProps) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt-br'>
    <div style={{ width: '100%' }}>
      <DatePicker
        label={label}
        inputFormat={format}
        renderInput={(params) => (
          <TextField
            size={size}
            data-testid={testId}
            autoComplete='off'
            fullWidth
            onKeyDown={(e) => readOnly && e.preventDefault()}
            {...params}
          />
        )}
        InputProps={{ readOnly }}
        value={currentValue || null}
        onChange={(value) => {
          if (value && isValidDate(value) && setCurrentValue) setCurrentValue(value)
        }}
        minDate={minDate}
        maxDate={maxDate}
        disableFuture={disableFuture}
      />
      {required && !currentValue && (
        <Typography variant='caption' color='error'>
          Campo obrigatório
        </Typography>
      )}
    </div>
  </LocalizationProvider>
)
